import { FAQButtonWrapper } from './FAQButtonStyles';
import { Icon } from '../../common/components/Icon/Icon';

import * as colors from '../../common/styles/colors';
import { FAQModal } from '../faq/FAQModal';
import { useState } from 'react';

type FAQButtonProps = {};

export const FAQButton = (props: FAQButtonProps) => {
  const [showFAQModal, setShowFAQModal] = useState<boolean>(false);

  const handleFAQButtonClick = () => {
    setShowFAQModal(true);
  };

  const handleFAQModalClose = () => {
    setShowFAQModal(false);
  };

  return (
    <>
      <FAQButtonWrapper onClick={handleFAQButtonClick}>
        <Icon color={colors.black} size={40} icon='bubble-question' />
        <span className='pl-1'>FAQ's</span>
      </FAQButtonWrapper>

      <FAQModal show={showFAQModal} onClose={handleFAQModalClose}></FAQModal>
    </>
  );
};
